import React from 'react';

const PercentageGraph = ({ percentage }) => {
  let barColor;

  if (!percentage) {
    barColor = '#f1f1f2';
  } else if (percentage <= 24.99) {
    barColor = '#fedb00';
  } else if (percentage <= 49.99) {
    barColor = '#ffec9c';
  } else if (percentage <= 74.99) {
    barColor = '#bff5aa';
  } else if (percentage <= 100) {
    barColor = '#6cc24a';
  }

  return (
    <div
      style={{
        width: '60px',
        backgroundColor: barColor,
        textAlign: 'center',
        padding: '8px 0',
      }}
    >
      <span style={{ fontWeight: 'bold' }}>
        {isNaN(percentage) ? 'NA' : `${percentage}%`}
      </span>
    </div>
  );
};

export default PercentageGraph;
